import { Dispatch, SetStateAction, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { SidebarModal } from '../../../components';
import Spinner from '../../../components/common/Spinner';
import { toggleDepositUlxModal } from '../../../slices/portfolio-slice';
import { Step1 } from './Step1';
import { Step2 } from './Step2';
import { Step3 } from './Step3';
import { DepositStepsEnum } from './types';
import { TokensType } from '../../../types/types';

interface DepositUlxProps {
  token: any;
  depositStep: number;
  setDepositStep: Dispatch<SetStateAction<DepositStepsEnum>>;
  ulx: string;
  usdt: string;
  setUlx: Dispatch<SetStateAction<string>>;
  setUsdt: Dispatch<SetStateAction<string>>;
  setBaseAkashaBalance: Dispatch<SetStateAction<number | undefined>>;
  baseAkashaBalance: number | undefined;
  ultronWUlxBalance: string | undefined;
  setUltronWUlxBalance: Dispatch<SetStateAction<string | undefined>>;
}

export const DepositUlx = ({
  token,
  setDepositStep,
  depositStep,
  ulx,
  usdt,
  setUlx,
  setUsdt,
  baseAkashaBalance,
  setBaseAkashaBalance,
  ultronWUlxBalance
}: DepositUlxProps) => {
  const dispatch = useAppDispatch();

  const { loadingDepositUlx, depositUlxModal } = useAppSelector(
    (state) => state.portfolio
  );

  const { walletSummary } = useAppSelector((state) => state.marketplace);

  const [selectedNetwork, setSelectedNetwork] = useState<any>();

  const depositSteps = (step: DepositStepsEnum) => {
    switch (step) {
      case DepositStepsEnum.COMPLETE_DEPOSIT:
        return (
          <Step1
            setDepositStep={setDepositStep}
            wallet={walletSummary?.userAddress}
            token={token}
            ulx={ulx}
            usdt={usdt}
            setUlx={setUlx}
            setUsdt={setUsdt}
            selectedNetwork={selectedNetwork}
            setSelectedNetwork={setSelectedNetwork}
            setBaseAkashaBalance={setBaseAkashaBalance}
            baseAkashaBalance={baseAkashaBalance}
            ultronWUlxBalance={ultronWUlxBalance}
          />
        );

      case DepositStepsEnum.SELECT_PAYMENT:
        return (
          <Step2
            wallet={walletSummary?.userAddress}
            token={token}
            selectedNetwork={selectedNetwork}
          />
        );

      case DepositStepsEnum.FINISH:
        return <Step3 />;

      default:
        break;
    }
  };

  const depositStepsTitle = (step: DepositStepsEnum) => {
    switch (step) {
      case DepositStepsEnum.COMPLETE_DEPOSIT:
        return `COMPLETE  ${token} DEPOSIT`;

      case DepositStepsEnum.SELECT_PAYMENT:
        return `ADD ${token} TO YOUR BACK OFFICE WALLET`;

      case DepositStepsEnum.FINISH:
        return '';

      default:
        break;
    }
  };

  return (
    <div>
      <SidebarModal
        isOpen={depositUlxModal}
        setOpen={(v) => {
          dispatch(toggleDepositUlxModal(v));
          setDepositStep(DepositStepsEnum.COMPLETE_DEPOSIT);
          setSelectedNetwork('');
        }}
        title={depositStepsTitle(depositStep)}
        sidebarWidth={'560px'}>
        {loadingDepositUlx && <Spinner transparent absolute />}
        {depositSteps(depositStep)}
      </SidebarModal>
    </div>
  );
};
